import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=5b6c0ad0&scoped=true"
import script from "./StudentForm.vue?vue&type=script&lang=ts"
export * from "./StudentForm.vue?vue&type=script&lang=ts"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=5b6c0ad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c0ad0",
  null
  
)

export default component.exports